module.exports = __webpack_public_path__ + "static/media/listening_hero.dea800e0.webp";